import { render, staticRenderFns } from "./landZu.vue?vue&type=template&id=58da88b5&scoped=true"
import script from "./landZu.vue?vue&type=script&lang=js"
export * from "./landZu.vue?vue&type=script&lang=js"
import style0 from "./landZu.vue?vue&type=style&index=0&id=58da88b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58da88b5",
  null
  
)

export default component.exports